export default __webpack_public_path__ + "64ca53541e3cdedf1829295aaaf3b60f.svg";